<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="popupConfig.hideOnOutsideClick"
    :show-close-button="false"
    :show-title="true"
    :width="width"
    :height="700"
    :title="popupConfig.title"
    :wrapper-attr="wrapperAttr"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    >
    </DxToolbarItem>
    <DxToolbarItem
      #default
      location="after"
      locate-in-menu="auto"
      :v-if="popupConfig.formMode !== 'create' && FriendlyStatus"
    >
      <gc-status-chip :status="FriendlyStatus" v-if="FriendlyStatus" />
    </DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />

    <div class="css-v2 gc-popup-form" v-if="popupConfig.isPopupShow">
      <gc-form
        :key="popupConfig.formKey"
        :form-options="{
          gcLabelLocation: 'left',
        }"
        ref="gc-header-form"
        :form-items="getHeaderFormItems"
        :is-normal="true"
        :data-model="model"
        :form-mode="popupConfig.formMode"
        :from-from="'gc-header-form-d-a'"
        :form-height="popupConfig.height - 85"
        v-if="IsFormLoaded"
      />
    </div>

    <div style="background-color: white" class="wo-data-details">
      <DxToolbar class="wo-so-toolbar" v-if="IsFormLoaded">
        <DxItem
          :options="{
            width: 'auto',
            dataSource: [
              {
                id: 0,
                text: 'Sales Orders',
              },
            ],
            selectedIndex: 0,
          }"
          location="before"
          widget="dxTabs"
        />
        <DxItem
          :options="{
            icon: 'plus',
            onClick: setSoLineModel,
          }"
          location="before"
          locate-in-menu="auto"
          widget="dxButton"
          :visible="getAddSOLineBtnVisibility"
        />
      </DxToolbar>

      <div class="wo-so-lines">
        <dx-data-grid
          v-if="IsFormLoaded"
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getSalesGridColumns"
          :data-source="getLocalDataSource"
          :row-alternation-enabled="true"
          :selection="{
            mode: getAddSOLineBtnVisibility ? 'multiple' : 'none',
          }"
          :height="280"
          :ref="'wo-so-line-grid'"
          @selection-changed="onSoListSelectionChanged"
          @content-ready="onContentReady"
        >
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal
              :dataValue="data"
              :format="data.column.format"
            /> </template
        ></dx-data-grid>
      </div>
    </div>

    <GcPopupAudit
      v-if="popupAuditVisible"
      :showPopup.sync="popupAuditVisible"
      :model.sync="auditModel"
    />

    <gcPopupWorkOrderSoLinesVue
      :popupConfig="soPopupConfig"
      :add-selected-so-lines="addSelectedSoLines"
      :pre-selected-items="soLinesDataSource._array"
      v-if="soPopupConfig.visible"
    />
  </DxPopup>
</template>
<script>
import { TransactionReportService } from "@/_services/api/reports/transaction-report.service";
import ApiService from "@/_services/api/api.service";
import { getGlobalField } from "@/_store/helpers";
import { b64toBlob } from "@/_helpers/pdf/pdf-helper";

import { WorkOrderService } from "../_services/api/production/work-order.service";
import { UserService } from "../_services/api/settings/user/user.service";
import { DefaultCompanyBranchDivisionService } from "../_services/api/sales/default-company-branch-dicision.service";
import { FeatureStorage } from "../_services/storage";
import { mapGetters } from "vuex";
import gcPopupWorkOrderSoLinesVue from "./gc-popup-work-order-so-lines.vue";
import ArrayStore from "devextreme/data/array_store";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";

export default {
  mixins: [DataGridMixin],
  components: { gcPopupWorkOrderSoLinesVue },
  data() {
    return {
      popupAuditVisible: false,
      auditModel: {
        createdBy: "",
        dateCreated: "",
        changedBy: "",
        dateChanged: "",
      },
      FriendlyStatus: undefined,
      model: {
        BomCode: null,
        Branch: null,
        QuoteCode: 0,
        Code: 0,
        Comments: "",
        CompanyCode: "",
        Division: null,
        Product: null,
        Quantity: 0,
        Required: new Date(),
        Scheduled: new Date(),
        DateIn: new Date(),
        MTSQuantity: 0,
        SOQuantity: 0,
      },
      IsFormLoaded: false,
      soPopupConfig: {
        visible: false,
      },
      soLinesDataSource: new ArrayStore({
        key: ["SalesOrderCode", "SalesOrderLine"],
        data: [],
      }),
      selectedRowsData: [],
      selectedBOMData: undefined,
      selectedProdData: undefined,
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onToolbarMenuItemOnClick: {
      type: Function,
      default: () => {},
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 600,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    applicationFeatureCode: {
      type: String,
      default: "WorkOrder",
    },
    ShowLoading: {
      type: Function,
      default: () => {},
    },
    saveCallBack: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
  },
  async created() {
    if (this.popupConfig.calendarDate) {
      this.model.Required = new Date(this.popupConfig.calendarDate);
    }

    if (
      this.popupConfig.workOrderCode &&
      (this.popupConfig.formMode === "review" ||
        this.popupConfig.formMode === "copy")
    ) {
      this.ShowLoading(true);
      // const response = await WorkOrderService.getByCode(
      //   this.popupConfig.workOrderCode
      // );
      // const workOrderDetail = response.data.value[0];
      const workOrderDetail = this.dataModel;
      // this.dataModel = { ...workOrderDetail };

      this.model.BomCode = workOrderDetail.BomCode;
      this.model.Branch = workOrderDetail.BranchCode;
      this.model.Code = workOrderDetail.Code;
      this.model.Comments = workOrderDetail.Comment;
      this.model.CompanyCode = workOrderDetail.CompanyCode;
      this.model.Division = workOrderDetail.DivisionCode;
      this.model.Product = workOrderDetail.ProductCode;
      this.model.Quantity = workOrderDetail.ItemQty;
      this.model.MTSQuantity = workOrderDetail.MTSQuantity;
      this.model.SOQuantity = workOrderDetail.SalesOrderStockUMQuantity;

      this.auditModel.createdBy = this.dataModel.CreatedBy;
      this.auditModel.dateCreated = this.dataModel.DateCreated;
      this.auditModel.changedBy = this.dataModel.ChangedBy;
      this.auditModel.dateChanged = this.dataModel.DateChanged;

      if (this.popupConfig.formMode === "copy") {
        this.model.Required = new Date();
        this.model.Scheduled = new Date();
        this.model.QuoteCode = 0;
      } else {
        this.model.QuoteCode = workOrderDetail.QuoteCode;
        this.model.Required = workOrderDetail.ShipDate;
        this.model.Scheduled = workOrderDetail.ScheduledDate;
      }

      if (this.popupConfig.formMode !== "copy")
        this.FriendlyStatus = this.dataModel.FriendlyStatus;

      const statusConditions = {
        Cancel: this.dataModel.FriendlyStatus !== "Active",
        Reopen:
          this.dataModel.FriendlyStatus !== "Completed" &&
          this.dataModel.FriendlyStatus !== "Cancelled",
        Complete: this.dataModel.FriendlyStatus !== "In Production",
      };

      this.getToolbarMenuItems.forEach((element) => {
        if (statusConditions[element.menuText] !== undefined) {
          element.disabled = statusConditions[element.menuText];
        }

        if (
          !FeatureStorage.checkPermission(this.applicationFeatureCode, "create")
        )
          element.disabled = true;
      });

      await this.getWOSalesOrderLines(workOrderDetail.Code);
      this.ShowLoading(false);
      this.IsFormLoaded = true;
    } else {
      DefaultCompanyBranchDivisionService.getDefault().then((result) => {
        const defaultData = result.data.value[0];
        this.model.CompanyCode = defaultData.CompanyCode;
      });

      this.IsFormLoaded = true;
    }
  },
  methods: {
    async getWOSalesOrderLines(code) {
      await WorkOrderService.getWOSOLines(code).then((res) => {
        res.data.value.forEach((element) => {
          element.SalesUMQuantity = element.SalesOrderSalesUMQuantity;
          element.StockUMQuantity = element.SalesOrderStockUMQuantity;
          element.SalesOrderShipDate = new Date(element.SalesOrderShipDate);
          this.soLinesDataSource.insert(element);
        });
      });
    },
    setSoLineModel() {
      this.soPopupConfig.ProductInfo = this.selectedProdData;
      this.soPopupConfig.visible = true;
    },
    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    /**
     * on popup model shown
     */
    onShown() {
      // if (this.dataModel) {
      //   this.FriendlyStatus = this.dataModel.FriendlyStatus;
      // }
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      setTimeout(() => this.setFocusOnField("BomCode"), 700);
    },

    /**
     * on pop up model hide
     */
    onPopupHide() {
      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    onInitialized(e) {
      if (this.popupConfig.formMode !== "review")
        e.component.registerKeyHandler("escape", (arg) => {
          arg.stopPropagation();
        });
    },

    /**
     * Preview PDF Report
     */
    async onPreviewPDF() {
      if (this.applicationFeatureCode) {
        this.ShowLoading(true);
        var response;
        await TransactionReportService.getByFeatureCode("ReportWorkOrder")
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            if (err) this.ShowLoading(false);
            this.$alert("Report repx not found", "Error");
            return;
          });

        var report = undefined;
        if (response && response.data) {
          report = response.data;
          report.Parameters = JSON.parse(response.data.Parameters);

          let link = `/api/GetReportPdf?reportLocation=${report.Location}`;

          report.Parameters.forEach((element) => {
            let globalField = { ...getGlobalField(element.screenField) };

            if (globalField) {
              link += `&${globalField.dataField}=${this.dataModel.Code}`;
            }
          });

          await ApiService.get(link)
            .then((res) => {
              const blob = b64toBlob(res.data, "application/pdf");
              const blobUrl = URL.createObjectURL(blob);
              this.ShowLoading(false);

              Object.assign(document.createElement("a"), {
                target: "_blank",
                href: blobUrl,
              }).click();
            })
            .catch((error) => {
              this.$logger.debug("ExportToPdf Error ", error);
              this.ShowLoading(false);
            });
        }
      }
    },

    /**
     * On Value Changed
     * @param e
     */
    async onBomValueChanged(e) {
      if (!e.event) return;

      let instance = e.component;

      if (e.value) {
        let selectedItem = instance
          .getDataSource()
          .items()
          .find((x) => x.Code === e.value);

        if (!selectedItem) {
          await WorkOrderService.getBOMByCode(e.value).then((res) => {
            selectedItem = res.data.value[0];
          });
        }

        if (!selectedItem) return;

        this.model.Product = selectedItem.ProductCode;

        if (this.model.SOQuantity != 0) {
          if (selectedItem.BatchSize > this.model.SOQuantity) {
            this.model.Quantity = selectedItem.BatchSize;
            this.model.MTSQuantity =
              this.model.Quantity - this.model.SOQuantity;
          } else this.Quantity = this.model.MTSQuantity + this.model.SOQuantity;
        } else {
          this.model.Quantity =
            selectedItem.BatchSize > 0 ? selectedItem.BatchSize : 1;
          // this.model.MTSQuantity = this.model.Quantity;
        }
        this.model.Branch = selectedItem.BranchCode;
        this.model.Division = selectedItem.DivisionCode;
        this.model.Comments = selectedItem.Comment;

        this.selectedBOMData = selectedItem;
      } else {
        this.model.Product = null;
        this.model.Comments = null;
        this.model.Branch = null;
        this.model.Division = null;
        if (this.model.SOQuantity === 0) {
          this.model.Quantity = 0;
          this.model.MTSQuantity = 0;
        }
      }
    },

    onEditPopupHandler() {
      this.popupConfig.formMode = "edit";
      this.popupConfig.hideOnOutsideClick = false;
      this.popupConfig.formKey++;
      if (this.dataModel.FriendlyStatus === "In Production")
        setTimeout(() => this.setFocusOnField("Comments"), 50);
      else setTimeout(() => this.setFocusOnField("Required"), 50);

      setTimeout(() => {
        this.$nextTick(() => {
          let grid = this.$refs["wo-so-line-grid"].instance;

          let IDs = [];
          this.soLinesDataSource._array.forEach((element) => {
            IDs.push({
              SalesOrderCode: element.SalesOrderCode,
              SalesOrderLine: element.SalesOrderLine,
            });
          });

          grid.selectRows(IDs, true);
        });
      }, 10);
    },

    /**
     * On Save Popup Handler
     */
    async onSavePopupHandler() {
      if (this.model.BomCode === "" || this.model.BomCode === null) {
        await this.$alert("Bom Code Required", "Validation Error");
        this.setFocusOnField("BomCode");
      } else if (this.model.Product === "" || this.model.Product === null) {
        await this.$alert("Product Code Required", "Validation Error");
        this.setFocusOnField("BomCode");
      } else if (this.model.Required === null) {
        await this.$alert("Required Date Required", "Validation Error");
        this.setFocusOnField("Required");
      } else if (this.model.Branch === "" || this.model.Branch === null) {
        await this.$alert("Branch Required", "Validation Error");
        this.setFocusOnField("Branch");
      } else if (this.model.Division === "" || this.model.Division === null) {
        await this.$alert("Division Required", "Validation Error");
        this.setFocusOnField("Division");
      } else if (this.model.Quantity === 0) {
        await this.$alert(
          "WO Quantity should be greater than 0.0000",
          "Validation Error"
        );
        this.setFocusOnField("Division");
      } else {
        const payload = {
          QuoteCode: this.model.QuoteCode,
          DateIn: new Date(this.model.Scheduled).toSaveDate(),
          RequiredDate: new Date(this.model.Required).toSaveDate(),
          CompanyCode: this.model.CompanyCode,
          BranchCode: this.model.Branch,
          DivisionCode: this.model.Division,
          BomCode: this.model.BomCode,
          ProductCode: this.model.Product,
          Comment: this.model.Comments,
          ItemQty: this.model.Quantity,
          Username: UserService.getUsername(),
          WorkOrderSalesOrderLines: [],
        };

        this.selectedRowsData.map((item) => {
          let lineItem = {
            WorkOrderCode: this.model.QuoteCode,
            SalesOrderCode: item.SalesOrderCode,
            SalesOrderLine: item.SalesOrderLine,
            SalesOrderStockUMQuantity: item.StockUMQuantity,
          };

          payload.WorkOrderSalesOrderLines.push(lineItem);
        });

        try {
          this.ShowLoading(true);
          const result = await WorkOrderService.save(payload);
          this.$notify(
            `Work order #${result.data.Code} is successfully ${
              this.popupConfig.formMode === "create" ? "created" : "updated"
            }`,
            "success"
          );
          this.ShowLoading(false);
          this.saveCallBack();
        } catch (e) {
          this.ShowLoading(false);
          await this.$alert(e.err, "Save Failed");
        }
      }
    },

    /**
     * Set Focus on Field
     * @param dataField
     */
    setFocusOnField(dataField) {
      if (
        this.$refs["gc-header-form"] &&
        this.popupConfig.formMode !== "review"
      ) {
        this.$refs["gc-header-form"].$refs["gc-form-comp"].instance
          .getEditor(dataField)
          .focus();
      }
    },

    /**
     * on Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        );
        if (confirm) {
          this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
          if (this.popupConfig.formMode === "create") {
            this.popupConfig.isPopupShow = false;
          } else {
            this.popupConfig.hideOnOutsideClick = true;
            this.popupConfig.formMode = "review";
            this.popupConfig.formKey++;
            this.popupConfig.isPopupShow = false;

            // await this.resetEditedData();
          }
        }
      }
    },

    async resetEditedData() {
      let workOrderDetail = this.dataModel;

      this.model.QuoteCode = workOrderDetail.QuoteCode;
      this.model.Comments = workOrderDetail.Comment;
      this.model.Quantity = workOrderDetail.ItemQty;
      this.model.Required = workOrderDetail.ShipDate;
      this.model.Scheduled = workOrderDetail.ScheduledDate;
    },

    /**
     * On Copy Work Order
     */
    onCopyWorkOrderHandler() {
      this.model.Required = new Date();
      this.model.Scheduled = new Date();
      this.model.QuoteCode = 0;
      this.FriendlyStatus = undefined;
      this.popupConfig.title = "Create Work Order";
      this.popupConfig.secondaryTitle = undefined;
      this.popupConfig.formMode = "copy";
      this.popupConfig.hideOnOutsideClick = false;
      this.popupConfig.formKey++;
    },

    /**
     * On Cancel Work Order
     */
    async onCancelWorkOrderHandler() {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this work order?",
        "Cancel Work Order"
      );

      if (confirmCancel) {
        this.ShowLoading(true);
        await WorkOrderService.cancelWorkOrder({
          Code: this.dataModel.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            if (res)
              this.$notify(
                `Work Order #${this.dataModel.Code} Successfully Cancelled`,
                "success"
              );
            this.ShowLoading(false);
            this.saveCallBack();
          })
          .catch((err) => {
            this.ShowLoading(false);
            this.displayServerError(err, "Cancel Work Order Failed");
          });
      }
    },

    /**
     * On Reopen Work Order Handler
     */
    async onReopenWorkOrderHandler() {
      let confirmReOrder = await this.$confirm(
        "Do you want to re-open this work order?",
        "Re-Open Work Order"
      );

      if (confirmReOrder) {
        this.ShowLoading(true);
        await WorkOrderService.reopenWorkOrder({
          Code: this.dataModel.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            if (res)
              this.$notify(
                `Work Order #${this.dataModel.Code} Successfully Re-Opened.`,
                "success"
              );
            this.ShowLoading(false);
            this.saveCallBack();
          })
          .catch((err) => {
            this.ShowLoading(false);
            this.displayServerError(err, "Re-Open Work Order Failed");
          });
      }
    },

    /**
     * On Complete Work Order Handler
     */
    async onCompleteWorkOrderHandler() {
      let confirmComplete = await this.$confirm(
        "Do you want to complete this work order?",
        "Complete Work Order"
      );

      if (confirmComplete) {
        this.ShowLoading(true);
        await WorkOrderService.completeWorkOrder({
          Code: this.dataModel.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            if (res)
              this.$notify(
                `Work Order #${this.dataModel.Code} Successfully Completed`,
                "success"
              );
            this.ShowLoading(false);
            this.saveCallBack();
          })
          .catch((err) => {
            this.ShowLoading(false);
            this.displayServerError(err, "Complete Work Order Failed");
          });
      }
    },

    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    /**
     * add selected so list from so model to wo model
     * @param soItems - selected items
     */
    addSelectedSoLines(soItems) {
      let IDs = [];

      soItems.forEach((element) => {
        element.SalesOrderShipDate = element.ShipDate;
        this.soLinesDataSource.insert(element).then(() => {
          IDs.push({
            SalesOrderCode: element.SalesOrderCode,
            SalesOrderLine: element.SalesOrderLine,
          });
        });
      });

      this.$nextTick(() => {
        let instance = this.$refs["wo-so-line-grid"].instance;
        if (instance)
          instance.refresh().then(() => {
            instance.selectRows(IDs, true);
          });
      });
    },

    /**
     * WO model so list grid item selected
     */
    onSoListSelectionChanged(e) {
      this.selectedRowsData = e.selectedRowsData;

      let Quantity = 0;
      let SOQuantity = 0;
      let MTSQuantity = 0;

      if (this.selectedRowsData.length > 0) {
        SOQuantity = this.selectedRowsData.reduce(
          (prev, curr) => prev + curr.StockUMQuantity,
          0.0
        );

        if (
          this.selectedBOMData &&
          this.selectedBOMData.BatchSize > SOQuantity
        ) {
          Quantity = this.selectedBOMData.BatchSize;
        } else Quantity = this.model.MTSQuantity + SOQuantity;

        MTSQuantity = Quantity - SOQuantity;
      } else {
        if (this.selectedBOMData && this.selectedBOMData.BatchSize > 0)
          Quantity = this.selectedBOMData.BatchSize;
        else Quantity = 1;
        MTSQuantity = Quantity;
      }

      var form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData("Quantity", Quantity);
      form.updateData("MTSQuantity", MTSQuantity);
      form.updateData("SOQuantity", SOQuantity);
      form.endUpdate();
    },

    onContentReady(e) {
      this.addGridNoResults(e, {
        addNew: {
          class: "add-new",
          title: "No Sales Orders",
          message: "No orders linked with this Work Order",
        },
      });
    },

    /**
     * WO Qty value changed
     * @param e - event
     */
    async onQuantityValueChanged(e) {
      if (!e.event) return;

      if (this.model.SOQuantity === 0 && e.value === 0) {
        await this.$alert(
          "You have attempted to set the WO Quantity to 0.0000. Please enter a WO Quantity that is greater than 0.0000",
          "Validation Error"
        );
        e.component.beginUpdate();
        e.component.option("value", e.previousValue);
        e.component.endUpdate();
        this.setFocusOnField("Quantity");
      } else if (this.model.SOQuantity > 0 && e.value < this.model.SOQuantity) {
        await this.$alert(
          `You have attempted to set the WO Quantity below the selected Sales Order Quantity. Please enter a WO Quantity that is greater than or equal to  ${this.model.SOQuantity}.`,
          "Validation Error"
        );

        e.component.beginUpdate();
        e.component.option("value", e.previousValue);
        e.component.endUpdate();
        this.setFocusOnField("Quantity");
      } else {
        this.model.MTSQuantity = e.value - this.model.SOQuantity;
      }
    },

    /**
     * MTS Qty value changed
     * @param e - event
     */
    async onMTSQuantityValueChanged(e) {
      let previousQtyValue = this.model.Quantity;
      this.model.Quantity = e.value + this.model.SOQuantity;

      if (this.model.Quantity === 0) {
        await this.$alert(
          "You have attempted to set the WO Quantity to 0.0000. Please enter a MTS Quantity that is greater than 0.0000",
          "Validation Error"
        );
        this.updateQtyFieldFromMTSQty(e, previousQtyValue);
      } else if (
        this.model.SOQuantity > 0 &&
        this.model.Quantity < this.model.SOQuantity
      ) {
        await this.$alert(
          `You have attempted to set the WO Quantity below the selected Sales Order Quantity. Please enter a WO Quantity that is greater than or equal to  ${this.model.SOQuantity}.`,
          "Validation Error"
        );

        this.updateQtyFieldFromMTSQty(e, previousQtyValue);
      }
    },

    updateQtyFieldFromMTSQty(e, previousQtyValue) {
      e.component.beginUpdate();
      e.component.option("value", e.previousValue);
      e.component.endUpdate();

      this.model.Quantity = previousQtyValue;
      this.setFocusOnField("MTSQuantity");
    },

    onBOMSelectionChanged(e) {
      if (this.popupConfig.formMode !== "create")
        this.selectedBOMData = e.selectedItem;
    },

    onProductSelectionChanged(e) {
      if (e.selectedItem) this.selectedProdData = e.selectedItem;
      else this.selectedProdData = undefined;
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "BOM",
                  dataField: "BomCode",
                  required: true,
                  label: {
                    text: "BOM",
                  },
                  editorOptions: {
                    showClearButton: true,
                    readOnly: this.popupConfig.formMode === "edit",
                    tabIndex: this.popupConfig.formMode === "edit" ? -1 : 1,
                    onValueChanged: this.onBomValueChanged,
                    select: [
                      "Code",
                      "Comment",
                      "Description1",
                      "Description2",
                      "ProductCode",
                      "BatchSize",
                      "BranchCode",
                      "DivisionCode",
                      "BomTypeCode",
                      "Status",
                    ],
                    onSelectionChanged: (e) => {
                      this.onBOMSelectionChanged(e);
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                  displayExpr: (e) => {
                    if (e) return `${e.Code} - ${e.Description1}`;
                    else return undefined;
                  },
                  searchExpr: [
                    "Code",
                    "Description1",
                    "Description2",
                    "ProductCode",
                  ],
                },
                {
                  screenField: "Branch",
                  dataField: "Branch",
                  required: true,
                  label: {
                    text: "Branch",
                  },
                  filter: ["ManufactureFlag", "=", "Y"],
                  editorOptions: {
                    tabIndex: -1,
                    readOnly: true,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "Product",
                  dataField: "Product",
                  allowUpdate: true,
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                    onSelectionChanged: (e) => {
                      this.onProductSelectionChanged(e);
                    },
                  },
                  displayExpr: (e) => {
                    if (e) return `${e.Code} - ${e.Description1}`;
                    else undefined;
                  },
                },
                {
                  screenField: "Division",
                  dataField: "Division",
                  required: true,
                  label: {
                    text: "Division",
                  },
                  editorOptions: {
                    tabIndex: -1,
                    readOnly: true,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "Required",
                      label: {
                        text: "Required",
                      },
                      format: "dd MMM yyyy",
                      editorOptions: {
                        showClearButton: true,
                        tabIndex:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production"
                            ? -1
                            : 3,
                        useMaskBehavior: true,
                        onFocusIn: (e) => {
                          e.event.target.select();
                        },
                        readOnly:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production",
                        min: new Date(),
                        onValueChanged: (e) => {
                          if (e.event) {
                            if (e.value < new Date()) {
                              e.component.beginUpdate();
                              e.component.option("value", e.previousValue);
                              e.component.endUpdate();
                            }
                          }
                        },
                      },
                      required: true,
                    },
                    {
                      visible: this.popupConfig.formMode === "review",
                      screenField: "DateIn",
                      dataField: "Scheduled",
                      label: {
                        text: "Scheduled",
                      },
                      format: "dd MMM yyyy",
                      editorOptions: {
                        tabIndex: 4,
                        useMaskBehavior: true,
                        onFocusIn: (e) => {
                          e.event.target.select();
                        },
                      },
                      required: true,
                    },
                  ],
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      dataField: "Quantity",
                      screenField: "WOQuantity",
                      allowUpdate: true,
                      required: true,
                      editorOptions: {
                        tabIndex:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production"
                            ? -1
                            : 5,
                        readOnly:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production",
                        min: this.model.SOQuantity,
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.onQuantityValueChanged(e);
                          }
                        },
                        onFocusIn: (e) => {
                          e.event.target.select();
                        },
                      },
                    },
                    {
                      dataField: "MTSQuantity",
                      screenField: "MTSQuantity",
                      allowUpdate: true,
                      required: true,
                      editorOptions: {
                        tabIndex:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production"
                            ? -1
                            : 6,
                        readOnly:
                          this.popupConfig.formMode === "edit" &&
                          this.dataModel.FriendlyStatus === "In Production",
                        min: 0,
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.onMTSQuantityValueChanged(e);
                          }
                        },
                        onFocusIn: (e) => {
                          e.event.target.select();
                        },
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      dataField: "SOQuantity",
                      screenField: "SOQuantity",
                      editorOptions: {
                        tabIndex: -1,
                        readOnly: true,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "Comments",
              screenField: "Comments",
              allowUpdate: true,
              editorType: "dxTextArea",
              editorOptions: {
                tabIndex: 8,
                height: 140,
                maxLength: 1000,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
            },
          ],
        },
      ];
    },
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: false, // This work is being deferred at this time as legacy does not support background printing of work orders atm. #54380
          options: {
            icon: "print",
            // onClick: this.onBackGrounPrintRequest,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode === "review",
          options: {
            icon: "pdffile",
            onClick: this.onPreviewPDF,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.popupConfig.formMode !== "copy",
          options: {
            icon: "clock",
            onClick: this.onAuditPopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode === "review" &&
            this.popupConfig.isEditable,
          options: {
            icon: "edit",
            onClick: this.onEditPopupHandler,
            visible:
              this.popupConfig.formMode === "review" &&
              this.popupConfig.isEditable,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Cancel",
            stylingMode: "outlined",
            type: "danger",
            onClick: this.onCancelPopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxDropDownButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.popupConfig.formMode !== "copy",
          options: {
            items: this.getToolbarMenuItems,
            icon: "fas fa-ellipsis-v",
            showArrowIcon: false,
            stylingMode: "text",
            onItemClick: this.onToolbarMenuItemOnClick,
            dropDownOptions: {
              minWidth: 90, // Set minimum width for dropdown items
            },
            displayExpr: "menuText",
            valueExpr: "menuText",
          },
        },
      ];
    },
    getToolbarMenuItems() {
      return [
        {
          menuText: "Copy",
          visible: true, // pending discussions #54331
          onClick: this.onCopyWorkOrderHandler,
        },
        { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler },
        { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
        { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },
      ];
    },
    getSalesGridColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Sales Order",
          dataField: "SalesOrderCode",
          width: ColumnWidth.SalesOrderNumber.width - 15,
          minWidth: ColumnWidth.SalesOrderNumber.minWidth - 15,
          alignment: "left",
        },
        {
          screenField: "Customer",
          allowSorting: true,
        },
        {
          screenField: "LineComment",
          caption: "Line #",
          dataField: "SalesOrderLine",
          width: ColumnWidth.LineInfo.width - 20,
          minWidth: ColumnWidth.LineInfo.minWidth - 20,
          alignment: "left",
          allowSorting: true,
        },
        {
          screenField: "ShipDate",
          dataField: "SalesOrderShipDate",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          format: "dd MMM yyyy",
          allowSorting: true,
        },
        {
          screenField: "Product",
          caption: "Product",
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "SalesUMQuantity",
          caption: "Sales UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "SalesUM",
          caption: "Sales UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "StockUMQuantity",
          caption: "Stock UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          caption: "",
          dataField: "",
          type: "selection",
          fixed: true,
          fixedPosition: "right",
          visible: this.getAddSOLineBtnVisibility,
          width: 30,
          minWidth: 30,
        },
      ]);
    },

    /**
     * Data Grid
     * @returns {ArrayStore<*, any>}
     */
    getLocalDataSource() {
      return this.soLinesDataSource;
    },

    getAddSOLineBtnVisibility() {
      if (this.popupConfig.formMode === "review") return false;
      else if (
        this.popupConfig.formMode !== "create" &&
        this.dataModel.FriendlyStatus === "In Production"
      )
        return false;
      else return true;
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupConfig.formMode !== "review") this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-work-order {
  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .wo-data-details {
    background-color: white;
    margin: 0px 10px;

    .wo-so-toolbar {
      .dx-icon.dx-icon-plus::before {
        color: #03a9f4;
      }
    }
  }

  .wo-so-lines {
    .dx-datagrid-header-panel {
      height: 0px !important;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 5px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-command-select.dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
</style>
